import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { PRICE_NEW, PRICE_OLD, SECURED_COUNT } from "../../lib/site";

const SecuredCounter = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    const controls = animate(0, SECURED_COUNT, {
      duration: 1.8,
      ease: "easeOut",
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView]);

  return (
    <div ref={ref} data-testid="secured-counter" className="mt-12 flex items-center gap-5">
      <span
        data-testid="secured-counter-value"
        className="font-display text-6xl font-semibold leading-none sm:text-7xl"
      >
        {value}
      </span>
      <span className="max-w-[200px] text-sm leading-snug text-white/75">
        lokali gastronomicznych zabezpieczyło się już tym pakietem
      </span>
    </div>
  );
};

export const PricingSection = ({ onBuy }) => (
  <section
    id="cena"
    data-testid="pricing-section"
    className="relative overflow-hidden bg-brick px-6 py-24 text-white sm:px-10 sm:py-32 lg:px-16"
  >
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -right-10 top-1/2 -translate-y-1/2 select-none font-display text-[16rem] font-semibold italic leading-none text-white/[0.06] sm:text-[24rem]"
    >
      219
    </span>
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(255,255,255,0.14),transparent_55%)]" />

    <div className="relative mx-auto flex max-w-4xl flex-col items-start">
      <Reveal>
        <Kicker index="04" label="Cena" light />
        <h2 className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Mniej niż jedna kara za brak dokumentacji
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-12">
        <div className="flex flex-wrap items-end gap-x-6 gap-y-3">
          <s data-testid="price-old" className="text-2xl font-medium text-white/50 sm:text-3xl">
            {PRICE_OLD}
          </s>
          <span
            data-testid="price-new"
            className="font-display text-7xl font-semibold leading-none tracking-tight sm:text-8xl"
          >
            {PRICE_NEW}
          </span>
          <span
            data-testid="price-savings"
            className="mb-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-white/90"
          >
            Oszczędzasz 1478 zł
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.18} className="mt-10">
        <button
          data-testid="pricing-cta-button"
          onClick={onBuy}
          className="group inline-flex items-center gap-3 rounded-full bg-choc px-10 py-5 text-base font-semibold text-white shadow-2xl shadow-choc-deep/40 transition-colors duration-300 hover:bg-choc-deep sm:text-lg"
        >
          Zabezpiecz swój lokal
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" />
        </button>
        <p
          data-testid="pricing-reassurance"
          className="mt-5 flex items-center gap-2 text-sm text-white/75"
        >
          <Lock className="h-4 w-4" />
          Płatność zabezpieczona przez Stripe · Dokumenty od ręki po zakupie
        </p>
        <SecuredCounter />
      </Reveal>
    </div>
  </section>
);
